import { Component, Input } from '@angular/core';

@Component({
    selector: 'marketplace-app-icon',
    templateUrl: './app-icon.component.html',
    styleUrls: ['./app-icon.component.scss'],
    standalone: false
})
export class AppIconComponent {
  @Input() icon = '';
  @Input() title = '';
  constructor() {}
}
